module.exports = __webpack_public_path__ + "img/retrobutton.20d9148a.jpg";